import React from "react";
import Translate from "localization/Translate";

export default function Header({title, children}){

    return (
        <div style={{
            backgroundColor: '#CCCCCC',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4.64rem',
            display: 'flex',
            alignItems: 'center'
        }}>
            <span style={{
                fontSize: '1.43rem',
                marginLeft: '1.43rem'
            }}>
                <Translate id={title}/>
            </span>
            { children }
        </div>
    );
}